import script from "./HomePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomePage.vue?vue&type=script&lang=ts&setup=true"

import "./HomePage.vue?vue&type=style&index=0&id=0cc8baf0&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0cc8baf0"]])

export default __exports__